module.exports = __webpack_public_path__ + "static/img/logoo.1cf90b06.png";